<template>
  <header class="panel animate__animated animate__fadeIn">
    <div
      :class="['menu-bar', showMenu ? 'show' : 'hide']"
      @mouseleave="leave"
      @mouseover="over"
    >
      <a-row
        type="flex"
        justify="space-between"
        :class="[
          autoHide ? 'animate__animated' : '',
          showMenu ? 'animate__fadeInDown' : 'animate__fadeOutUp',
        ]"
      >
        <a-col :span="2">
          <div class="logo">
            <router-link to="/"><img src="/logo.png" alt="" /></router-link>
          </div>
        </a-col>
        <a-col :span="16">
          <a-menu mode="horizontal" class="menu" :subMenuCloseDelay="1">
            <a-sub-menu key="create">
              <span slot="title" class="submenu-title-wrapper">
                <a-icon type="code" />开始创作
              </span>
              <a-menu-item key="create:scratch">
                <a href="/scratch3/index.html?scene=create" target="_blank"
                  >Scratch</a
                >
              </a-menu-item>
              <a-menu-item key="create:scratchjr">
                <a href="/scratchjr/home.html" target="_blank">ScratchJr</a>
              </a-menu-item>
              <a-menu-item key="create:turtle">
                <a href="/onlinecode/index.html?lang=turtle" target="_blank"
                  >图形化Python</a
                >
              </a-menu-item>
              <a-menu-item key="create:python">
                <a href="/onlinecode/index.html?lang=python" target="_blank"
                  >Python</a
                >
              </a-menu-item>
              <a-menu-item key="create:cpp">
                <a href="/onlinecode/index.html?lang=cpp" target="_blank"
                  >C++</a
                >
              </a-menu-item>
              <a-menu-item key="create:c">
                <a href="/onlinecode/index.html?lang=c" target="_blank"
                  >C语言</a
                >
              </a-menu-item>
              <a-menu-item key="create:java">
                <a href="/onlinecode/index.html?lang=java" target="_blank"
                  >Java</a
                >
              </a-menu-item>
            </a-sub-menu>
            <a-menu-item key="community">
              <router-link to="/community">
                <a-icon type="message" />社区
              </router-link>
            </a-menu-item>
            <a-menu-item key="contest">
              <router-link to="/contest">
                <a-icon type="trophy" />比赛
              </router-link>
            </a-menu-item>
            <a-menu-item key="app">
              <router-link to="/course">
                <a-icon type="book" />课程
              </router-link>
            </a-menu-item>
          </a-menu>
        </a-col>
        <a-col :span="6">
          <div v-if="userInfo && userInfo.id" class="login-btn-wrap">
            <a-menu mode="horizontal" class="user-menu">
              <a-sub-menu key="create">
                <span slot="title" class="submenu-title-wrapper">
                  <router-link to="/center/studentCenter">
                    <a-avatar
                      style="backgroundcolor: #87d068"
                      icon="user"
                      :src="userInfo.avatarUrl || '/img/avatar.png'"
                    />
                    {{ userInfo.realname }}
                  </router-link>
                </span>
                <a-menu-item key="center:student">
                  <router-link to="/center/studentCenter">
                    个人中心
                  </router-link>
                </a-menu-item>
                <a-menu-item key="center:project">
                  <a href="" target="_blank">作品管理</a>
                </a-menu-item>
                <a-menu-item key="center:account">
                  <a href="" target="_blank">账户设置</a>
                </a-menu-item>
                <a-menu-item key="center:logout">
                  <a @click="handleLogout" target="_blank">退出登录</a>
                </a-menu-item>
              </a-sub-menu>
            </a-menu>
          </div>
          <div v-else class="login-btn-wrap">
            <a-avatar
              @click="showLogin = true"
              icon="user"
              :src="'/img/avatar.png'"
            />
            <span @click="showLogin = true">登录</span>
            <a-divider type="vertical" />
            <span @click="showRegister = true">注册</span>
          </div>
        </a-col>
      </a-row>
    </div>

    <a-modal
      v-model="showLogin"
      :mask="true"
      :keyboard="false"
      :maskClosable="false"
      :footer="null"
      title="登录"
    >
      <Login @success="loginSuccess" />
    </a-modal>
    <a-modal
      v-model="showRegister"
      :mask="true"
      :keyboard="false"
      :maskClosable="false"
      :footer="null"
      title="注册"
    >
      <Register @success="regSuccess" />
    </a-modal>
  </header>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { mapActions } from "vuex";
import Login from "../views/user/Login";
import Register from "../views/user/Register";
export default {
  name: "Menu",
  props: {
    autoHide: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Login,
    Register,
  },
  data() {
    return {
      showLogin: false,
      showRegister: false,
      userInfo: {},
      showMenu: true,
    };
  },
  created() {
    let that = this;
    this.userInfo = this.$store.state.user.info;
    console.log("用户信息：");
    console.log(this.userInfo);
    //需要登录的页面
    const loginPageList = ["/center/mineCourse", "/center/student"];
    document.addEventListener("tokenInvaild", function (e) {
      if (loginPageList.includes(window.location.pathname)) {
        that.showLogin = true;
      }
    });
  },
  methods: {
    ...mapActions(["Logout"]),
    leave() {
      if (this.autoHide) this.showMenu = false;
    },
    over() {
      if (this.autoHide) this.showMenu = true;
    },
    loginSuccess() {
      this.showLogin = false;
      this.userInfo = this.$store.state.user.info;
    },
    regSuccess() {
      this.showRegister = false;
      this.showLogin = true;
    },
    handleLogout() {
      const that = this;
      this.$confirm({
        title: "提示",
        content: "真的要注销登录吗 ?",
        onOk() {
          return that
            .Logout({})
            .then(() => {
              that.$router.push({ path: "/user/login" });
            })
            .catch((err) => {
              that.$message.error({
                title: "错误",
                description: err.message,
              });
            });
        },
        onCancel() {},
      });
    },
  },
};
</script>
<style lang="less" scoped>
.show {
}
.hide {
  height: 50px;
  background-color: transparent !important;
  transition: all 0.1s ease;
}
.menu-bar {
  width: 100%;
  padding: 9px 10%;
  background-color: #448af0e6;
  transition: all 0.1s ease;
  // position: fixed;

  .logo {
    img {
      height: 50px;
    }
  }
  .menu {
    background: transparent;
    border-bottom: unset;
    .ant-menu-submenu,
    .ant-menu-item > a {
      font-size: 20px;
      font-weight: 700;
      color: white !important;
    }
    .ant-menu-submenu-active,
    .ant-menu-item-active {
      background: rgba(0, 0, 0, 0.2);
      // border-radius: 15px;
      border-bottom: none !important;
    }
  }
  .user-menu {
    background: transparent;
    border-bottom: unset;
    font-size: 18px;
    span {
      a {
        color: white;
      }
      .ant-avatar {
        font-size: 20px;
      }
    }
  }
  .login-btn-wrap {
    .ant-avatar {
      margin-right: 5px;
    }
    span {
      color: white;
    }
  }
}
</style>